import { usePostHttp } from "../../http.hook";

interface IBody {
  id: string;
  otp: string;
}

interface IResponse {
  user: {
    phoneNumber: string;
    name: string;
  };
}

export function useVerifyPhoneBrandHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/profile/phone",
  });
}
